import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { HeadingTwo, HeadingThree, Paragraph } from "../elements"
import {
  breakpointXL,
  breakpointMedium,
  linkAccent,
  textColorDark,
} from "../variables"

export const query = graphql`
  {
    allPrismicContact {
      edges {
        node {
          data {
            title {
              text
            }
            description {
              html
            }
            phone_number {
              text
            }
            social_media {
              social_title {
                text
              }
              media_link {
                url
              }
            }
          }
        }
      }
    }
  }
`

const Contact = ({ data }) => {
  const {
    title,
    description,
    phone_number,
    social_media,
  } = data.allPrismicContact.edges[0].node.data

  return (
    <Layout>
      <SEO title="Contact" />
      <HeadingTwo
        fontSize="36px"
        fontWeight="400"
        textAlign="center"
        padding="74px 0 93px 0"
      >
        {title.text}
      </HeadingTwo>
      <ContactContainer>
        <div>
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: description.html }}
          ></div>

          <HeadingThree
            margin="44px 0 7px 0"
            fontSize="15px"
            textTransform="uppercase"
          >
            Phone Number:
          </HeadingThree>
          <Paragraph
            color={textColorDark}
            className="phone-number"
            fontWeight="600"
            fontSize="26px"
          >
            {phone_number.text}
          </Paragraph>

          <HeadingThree
            margin="40px 0 12px 0"
            fontSize="15px"
            textTransform="uppercase"
          >
            Social Media:
          </HeadingThree>
          <div className="social-links">
            <a href={social_media[0].media_link.url}>
              <InstagramSVG />
            </a>
            <a href={social_media[1].media_link.url}>
              <FacebookSVG />
            </a>
            <a href={social_media[2].media_link.url}>
              <YoutubeSVG />
            </a>
            <a href={social_media[3].media_link.url}>
              <LinkedinSVG />
            </a>
          </div>
        </div>
        <iframe
          id="JotFormIFrame-90524458668165"
          title="Mahi Pono Webpage Contact Us "
          allowtransparency="true"
          allowFullScreen={true}
          allow="geolocation; microphone; camera"
          src="https://form.jotform.com/deakin09/MahiPonoContactUs"
          frameBorder="0"
          scrolling="yes"
        >
          {" "}
        </iframe>
      </ContactContainer>
    </Layout>
  )
}

export default Contact

const ContactContainer = styled.section`
  max-width: 1109px;
  margin: 0 auto;
  display: grid;
  padding: 0 20px 196px 20px;
  grid-gap: 62px;

  .social-links {
    display: grid;
    width: fit-content;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
    align-items: center;

    a {
      width: 100%;
    }
    svg {
      height: 20px;
      width: 100%;

      path,
      circle {
        fill: ${textColorDark};
      }
    }
  }

  iframe {
    min-width: 100%;
    min-height: 100vh;
    height: fit-content;
  }

  .description {
    font-size: 20px;
    line-height: 1.6;
    color: ${textColorDark};

    a {
      text-decoration: underline;
      color: ${linkAccent};
    }
  }

  @media (min-width: ${breakpointMedium}) {
    grid-template-columns: 1fr 731px;
    padding: 0 0 196px 0;

    .social-links {
      svg {
        height: 27px;
      }
    }

    .phone-number {
      font-size: 34px;
    }

    .description {
      font-size: 24px;
    }
  }

  @media (min-width: ${breakpointXL}) {
    min-width: 1440px;
    grid-template-columns: 1fr 919px;
    padding: 0 0 253px 0;
  }
`

const InstagramSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.011"
    height="18.01"
    viewBox="0 0 18.011 18.01"
  >
    <g id="Group_48" data-name="Group 48" transform="translate(-0.993 -0.993)">
      <path
        id="Path_100"
        data-name="Path 100"
        d="M10,5.32a4.645,4.645,0,1,0,.01,0Zm0,7.62a3,3,0,1,1,3-3A3,3,0,0,1,10,12.94Z"
        fill="#fff"
      />
      <circle
        id="Ellipse_4"
        data-name="Ellipse 4"
        cx="1.05"
        cy="1.05"
        r="1.05"
        transform="translate(13.78 4.16)"
        fill="#fff"
      />
      <path
        id="Path_101"
        data-name="Path 101"
        d="M17.55,2.49A5.191,5.191,0,0,0,13.74,1H6.26A5,5,0,0,0,1,5.726,4.756,4.756,0,0,0,1,6.26V13.7a5.243,5.243,0,0,0,1.52,3.88A5.283,5.283,0,0,0,6.3,19h7.4a5.339,5.339,0,0,0,3.81-1.42A5.182,5.182,0,0,0,19,13.74V6.26A5.21,5.21,0,0,0,17.55,2.49Zm-.22,11.25a3.53,3.53,0,0,1-1,2.65,3.771,3.771,0,0,1-2.65.94H6.3a3.771,3.771,0,0,1-2.65-.94,3.668,3.668,0,0,1-1-2.69V6.26a3.642,3.642,0,0,1,1-2.65A3.722,3.722,0,0,1,6.3,2.67h7.47a3.632,3.632,0,0,1,2.65,1,3.718,3.718,0,0,1,1,2.61v7.48Z"
        fill="#fff"
      />
    </g>
  </svg>
)

const FacebookSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.693"
    height="20.637"
    viewBox="0 0 10.693 20.637"
  >
    <path
      id="f"
      d="M30.752,33.193V23.821h3.168l.484-3.652H30.752V17.836c0-1.056.308-1.8,1.8-1.8h1.936v-3.3a27.739,27.739,0,0,0-2.816-.132c-2.816,0-4.708,1.716-4.708,4.84v2.728H23.8v3.652h3.168v9.417h3.784Z"
      transform="translate(-23.8 -12.6)"
      fill="#4a3c31"
    />
  </svg>
)

const LinkedinSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.177"
    height="20.242"
    viewBox="0 0 21.177 20.242"
  >
    <path
      id="Path_255"
      data-name="Path 255"
      d="M268.873,128.819v-7.83c0-4.2-2.239-6.147-5.226-6.147a4.5,4.5,0,0,0-4.091,2.256v-1.936h-4.54c.06,1.282,0,13.657,0,13.657h4.54v-7.627a3.1,3.1,0,0,1,.149-1.106,2.484,2.484,0,0,1,2.329-1.66c1.643,0,2.3,1.252,2.3,3.088v7.307ZM250.234,113.3a2.529,2.529,0,1,0-.028,0Zm2.27,15.521V115.162h-4.538v13.657Z"
      transform="translate(-247.696 -108.578)"
      fill="#4a3c31"
    />
  </svg>
)

const YoutubeSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.461"
    height="17.123"
    viewBox="0 0 24.461 17.123"
  >
    <path
      id="Path_256"
      data-name="Path 256"
      d="M26.225,8.431a3.423,3.423,0,0,0-3.118-3.105C21.191,5.166,18.349,5,14.842,5c-4.222,0-7.411.172-9.47.334A3.424,3.424,0,0,0,2.236,8.443C2.109,9.77,2,11.523,2,13.613c0,2.039.109,3.761.234,5.071A3.424,3.424,0,0,0,5.37,21.789c2.061.161,5.249.334,9.473.334,3.507,0,6.349-.166,8.265-.325a3.423,3.423,0,0,0,3.118-3.105c.127-1.321.236-3.061.236-5.131S26.352,9.752,26.225,8.431ZM11.511,17.156V9.967L18.6,13.561Z"
      transform="translate(-2 -5)"
      fill="#4a3c31"
    />
  </svg>
)
